/**
 * @Description
 */

import { FC } from 'react';
import styles from './index.module.less';
import Header from '../Header';

const LivePictures:FC<any> = ({
  img,
  imgList,
  type
}) => {

  return (
    <div className={styles['page']}>
      <Header title='现场勘查照片'/>

      {type === 'horizon'
        ? <div className={styles['horizon']}>
          <img src={img} className={styles['horizon-img']}/>
        </div>
        : <div className={styles['vertical']} style={{ justifyContent: imgList.length === 1 ? 'center' : 'space-between' }}>
          {imgList.length ? imgList?.map((item, index) => {
            return (
              <img src={item} key={index} className={styles['vertical-img']}/>
            );
          }) : <></>}
        </div>
      }

    </div>
  );
};

export default LivePictures;

